import axios from 'axios'
import qs from 'qs';
// import store from '../../src/store/index';
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);

axios.interceptors.request.use(function (config) {
  // debugger
  // if(config.url.includes('/user/WeiXin/login') != true && config.url.includes('/user/user/login') != true) { // 登录接口不传token
  //   const token = window.localStorage.getItem('token');
  //   config.headers.Token = token;
  //   // if(!token) {
  //   // }
  // }
  // debugger
  // const token = window.localStorage.getItem('token');
  // config.headers['Authorization'] = 'eyJhbGciOiJIUzI1NiIsInppcCI6IkdaSVAifQ.H4sIAAAAAAAAAKtWKi5NUrJSMjG2MFXSUSotTi3yTFGyAnF1lHLy0zPzQioLUpWszA10lIByZZnJqRABQ6BAakUBkGFmZmBpbmpuZFoLANXVC6lNAAAA.a1gWKYvyv_j-Os-cWL60ti8_k9jiifCOsOfxzjYL4rE'
  //  token需要替换
  config.headers['Authorization'] = localStorage.getItem('token')
  config.headers['source'] = "community"
  // if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
  //   config.data = qs.stringify(config.data)
  // }
  // if (config.headers['Content-Type'] === 'multipart/form-data') {
  //   let fd = new FormData();
  //   fd.append('uploadFile', config.formdata);
  //   config.data = fd
  // }
  // const action = window.localStorage.getItem('action');
  // if(action) {
  //   config.headers.action = action;
  // }
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  if (response.data) {
    if(response.data.code != 200) {
      // Toast.fail(response.data.message);
      // if(response.data.code == 1000001 || response.data.code == 1000002 || response.data.code == 1000003 || response.data.code == 1000004) {

      // }else {
      // }
    }
    if (typeof(response.data) === 'string') {
      response.data = JSON.parse(eas.decrypt(response.data))
    }
    return response.data
  }
  Toast.clear();
  return response;
}, function (error) {
  Toast.clear();
  return Promise.reject(error);
  
});
export default axios


// WEBPACK FOOTER //
// ./src/request/http.js